module.exports = __webpack_public_path__ + "static/media/chep.e33b4167.png";